import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IDragData, IExportState, StateType } from '@/version-types';

export interface IDragGhostState {
    defaultWidth: number;
    defaultHeight: number;
    maxWidth: number;
    maxHeight: number;
    offsetX: number;
    offsetY: number;
    startX: number;
    endX: number;
}

/** 状态 */
interface IState {
    /** 拖拽内容 */
    dragData: IDragData | null;
    /** 拖拽预览元素 */
    ghost: HTMLElement | null;
    /** 当前拖拽预览状态 */
    dragGhost: IDragGhostState | null;
}

/** 动作 */
interface IAction {
    /** 设置拖拽内容 */
    setDragData: (dragData: IDragData | null) => void;
    /** 设置拖拽预览元素 */
    setGhost: (ghost: HTMLElement | null) => void;
    /** 设置拖拽预览状态 */
    setDragGhost: (dragGhost: IDragGhostState | null) => void;
    /** 重置拖拽状态 */
    reset: () => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 初始化状态 */
function getInitialState() {
    return {
        dragData: null,
        ghost: null,
        dragGhost: null,
    };
}

/** 创建存储 */
const createState = (_identity: string) => {
    const store = create<IStore>((set) => ({
        ...getInitialState(),

        setDragData(dragData) {
            set({ dragData });
        },

        setGhost(ghost) {
            set({ ghost });
        },

        setDragGhost(dragGhost) {
            set({ dragGhost });
        },

        reset() {
            set(getInitialState());
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'drag-layer-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useDragLayerState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getDragLayerState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
